import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { AddServiceContactsDrawer } from './AddServiceContactsDrawer';
import { AddServiceContactsForClientsDrawer } from './AddServiceContactsForClientsDrawer';
import { AssociateContactToClientDrawer } from './AssociateContactToClientDrawer';
import { AssociateFolderToClientDrawer } from './AssociateFolderToClientDrawer';
import { AssociateResourceToClientDrawer } from './AssociateResourceToClientDrawer';
import { ClientContactIntakeDrawer } from './ClientContactIntakeDrawer';
import { ClientContactUpdateDrawer } from './ClientContactUpdateDrawer';
import { ClientIntakeDrawer } from './ClientIntakeDrawer';
import { ClientUpdateDrawer } from './ClientUpdateDrawer';
import { ClientUserGroupDrawer } from './ClientUserGroupDrawer';
import { EditColumnsDrawer } from './EditColumnsDrawer';
import LinkFoldersToClientsModal from './LinkFoldersToClients';
import { SuggestedContactsDrawer } from './SuggestedContactsDrawer';

export function addOverlays(piral: PiletApi) {
	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client:intake',
		props => {
			return <ClientIntakeDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '500px',
			},
		}
	);

	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client-contact:intake',
		props => {
			return <ClientContactIntakeDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);

	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client-contact:update',
		props => {
			return <ClientContactUpdateDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);

	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client-contacts:edit-columns',
		props => {
			return <EditColumnsDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);

	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client-update',
		props => {
			return <ClientUpdateDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);
	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:service-contacts:add',
		props => {
			return <AddServiceContactsDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);
	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:service-contacts-multiple-clients:add',
		props => {
			return <AddServiceContactsForClientsDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);
	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client-associate-resources:intake',
		props => {
			return <AssociateResourceToClientDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);
	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client-associate-contacts:intake',
		props => {
			return <AssociateContactToClientDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);
	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client-associate-folder:intake',
		props => {
			return <AssociateFolderToClientDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);
	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:suggested-contacts',
		props => {
			return <SuggestedContactsDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);

	piral.registerModal(
		'urn:sfmodal:client-mgt-pilet:alias-folder',
		() => <LinkFoldersToClientsModal />,
		{}
	);

	piral.registerDrawer(
		'urn:sfdrawer:client-mgt-pilet:client-user-group',
		props => {
			return <ClientUserGroupDrawer {...props} />;
		},
		{
			drawerProps: {
				width: '400px',
			},
		}
	);
}
